import { render, staticRenderFns } from "./PopularProductMobile.vue?vue&type=template&id=36894791&scoped=true"
import script from "./PopularProductMobile.vue?vue&type=script&lang=js"
export * from "./PopularProductMobile.vue?vue&type=script&lang=js"
import style0 from "./PopularProductMobile.vue?vue&type=style&index=0&id=36894791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36894791",
  null
  
)

export default component.exports